var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6665H5.33333V15.3332H8V12.6665ZM13.3333 12.6665H10.6667V15.3332H13.3333V12.6665ZM18.6667 12.6665H16V15.3332H18.6667V12.6665ZM21.3333 3.33317H20V0.666504H17.3333V3.33317H6.66667V0.666504H4V3.33317H2.66667C1.18667 3.33317 0.0133333 4.53317 0.0133333 5.99984L0 24.6665C0 26.1332 1.18667 27.3332 2.66667 27.3332H21.3333C22.8 27.3332 24 26.1332 24 24.6665V5.99984C24 4.53317 22.8 3.33317 21.3333 3.33317ZM21.3333 24.6665H2.66667V9.99984H21.3333V24.6665Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.13208eb942c9dad4c8387ccf061164c9.svg";
export { ForwardRef as ReactComponent };